<template > 
    <div v-resize="onResize" v-if="data != null">
        <h2>First preference count for the division of {{ division }} ({{ state }})</h2>
        <br/>    
        <loader v-if="loading" />

        <v-menu v-if="this.isMobile && data.length > 2" d-inline  :close-on-content-click="true">
            <v-btn outline small slot="activator">
                Sort <v-icon>sort</v-icon>
            </v-btn>
            <v-list>
                <v-subheader>
                    Sort by:
                </v-subheader>
                <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.text != '%' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                    <v-list-tile-title>
                        {{ item.text }}
                        <v-icon v-if="pagination.sortBy === item.value">{{pagination.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <v-data-table v-if="!loading && data.length > 2" :headers="headers"                    
                    :items="data"
                    :disable-initial-sort="true"
                    :hide-headers="isMobile"
                    :hide-default-header="isMobile"
                    :hide-default-footer="isMobile"
                    :pagination.sync="pagination"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    hide-actions>

            <template v-slot:items="props">
                <tr v-if="isMobile">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item pt-2">
                                <h3 class="pb-xs-0">
                                    <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                                    <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                                        {{ props.item.Candidate }}
                                    </router-link>
                                </h3>
                            </div>
                            <div class="flex-item" v-if="props.item.Candidate != 'Total'" data-label="Party">
                                <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                                <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                                    {{ props.item.PartyLinkedName }}
                                </router-link>
                            </div>
                            <div class="flex-item" v-if="props.item.Status != '' && props.item.Candidate != 'Total'" data-label="Status">
                                {{ props.item.Status }}
                            </div>
                            <div class="flex-item" v-if="props.item.Status == '' && props.item.Candidate != 'Total'" >
                                <!-- Leave empty -->
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-30" data-label="Votes">
                                {{ props.item.Votes }}
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-40" v-if="props.item.Candidate != 'Total'" data-label="Percentage (%)">
                                {{ props.item.Percentage }}
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-30" v-if="showSwing && props.item.Candidate != 'Total'" data-label="Swing (%)">
                                {{ props.item.Swing }}
                            </div>
                            
                        </div>
                    </td>
                </tr>
                <tr v-else>
                    <td class="text-xs-left">
                        <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                        <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                            {{ props.item.Candidate }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">
                        <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                        <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                            {{ props.item.PartyLinkedName }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.Votes }}</td>
                    <td class="text-xs-left">{{ props.item.Percentage }}</td>
                    <td class="text-xs-left" v-if="showSwing">{{ props.item.Swing }}</td>
                    <td class="text-xs-left">{{ props.item.Status }}</td>
                </tr>
            </template>
        </v-data-table>           
        <v-data-table v-if="!loading && data.length <= 2" :headers="unopposedHeaders"                    
                    :items="data"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :disable-initial-sort="true"
                    hide-actions>

            <template v-slot:items="props">
                <tr v-if="isMobile">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item pt-2">
                                <h3 class="pb-xs-0">
                                    <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                                    <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                                        {{ props.item.Candidate }}
                                    </router-link>
                                </h3>
                            </div>
                            <div class="flex-item" v-if="props.item.Candidate != 'Total'" data-label="Party">
                                <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                                <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                                    {{ props.item.PartyLinkedName }}
                                </router-link>
                            </div>
                            <div class="flex-item" v-if="props.item.Status != ''  && props.item.Status == 'Elected' && props.item.Candidate != 'Total'" data-label="Status">
                                {{ props.item.Status }}
                            </div>
                            <div class="flex-item" v-if="props.item.Status == 'Elected' && props.item.Candidate != 'Total'" >
                                Elected unopposed
                            </div>
                        
                        </div>
                    </td>
                </tr>
                <tr v-else>
                    <td class="text-xs-left">
                        <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                        <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                            {{ props.item.Candidate }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">
                        <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                        <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                            {{ props.item.PartyLinkedName }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.Status === 'Elected' ? 'Elected unopposed' : props.item.Status }}</td>
                </tr>
            </template>
        </v-data-table>           
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'year', 'state', 'electionId'],
    components: {
        Loader
    },
    created() {
        this.initialiseData();
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            data: [],
            isMobile: false,
            loading: true,
            pagination: {
                rowsPerPage: -1,
                sortBy: '',
                descending: false
            },
            unopposedHeaders: [{
                text: 'Candidate',
                value: 'Candidate'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Status',
                value: 'Status'
            }]
        }
    },
    computed: {
        headers() {
            const headers = [{
                text: 'Candidate',
                value: 'Candidate'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Votes',
                value: 'Votes'
            },
            {
                text: '%',
                value: 'Percentage'
            },
            {
                text: 'Status',
                value: 'Status'
            }]
            if (this.showSwing) {
                headers.splice(headers.length - 1, 0, {
                    text: 'Swing',
                    value: 'Swing'
                });

            }
            return headers;
        },
        showSwing() {
            return this.data.findIndex(d => d.Swing > 0) !== -1;
        },
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/FirstPreferenceCount?divisionName=${this.division}&year=${this.year}&electionId=${this.electionId}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data ? response.data.Candidates : null;
                    this.loading = false;
                });
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } 
            else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
    }
}

</script>
